import { useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { PayoutDetailApiAdapter } from '../adapters';

interface UsePayoutDetailProps {
  payoutId: number;
  enabled?: boolean;
}

export const usePayoutDetail = ({
  payoutId,
  enabled = true,
}: UsePayoutDetailProps) => {
  const httpClient = createHttpClient(apiClientWH);
  const payoutDetailAdapter = new PayoutDetailApiAdapter(httpClient);

  const { data, isLoading, isFetching, error, refetch } = useQuery({
    queryKey: ['cod-payout-detail', payoutId],
    queryFn: () => payoutDetailAdapter.getPayoutById(payoutId),
    enabled: enabled && !!payoutId,
    staleTime: 2 * 60 * 1000, // 2 minutos
    gcTime: 5 * 60 * 1000, // 5 minutos
  });

  return {
    payout: data,
    isLoading,
    isFetching,
    error: error ? (error as Error).message : null,
    refetch,
  };
};

